exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/app/scroll-to-top/scroll-to-top.component.scss
// module id = ../../../../../src/app/scroll-to-top/scroll-to-top.component.scss
// module chunks = main